import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { AgritourismService } from '../../../services/agritourism.service';

@Component({
  selector: 'curbnturf-agritourism-day-two',
  templateUrl: './day-two.component.html',
  styleUrls: ['./day-two.component.scss'],
  standalone: true,
  imports: [RouterModule, VgCoreModule, VgOverlayPlayModule, VgBufferingModule, VgControlsModule],
})
export class AgritourismDayTwoComponent {
  constructor(
    private agritourismService: AgritourismService,
    private router: Router,
  ) {}

  complete() {
    this.agritourismService.complete(2).subscribe(() => {
      this.router.navigate(['', 'course', 'day-3']);
    });
  }
}
